/* eslint-disable react/button-has-type */
import * as React from 'react';

import { FlameTheme } from '@lightspeed/flame/Core';

import { translate } from 'pages/utils/translate';

export const GiftCardScan = () => {
  return (
    <FlameTheme>
      <span id="scanGiftCardLabel">{translate('Scan Gift Card Code')}</span>
      <table
        className="payments_list"
        style={{ width: '100%', border: 0 }}
        cellPadding="0"
        cellSpacing="0"
      >
        <tbody>
          <tr>
            <th>
              <input
                id="gift_card_input"
                className="giftcardbarcode"
                type="text"
                autoComplete="off"
                style={{ width: '100%' }}
              />
            </th>
          </tr>
          <tr>
            <td>
              <button
                id="scanGiftCardGoButton"
                style={{ fontWeight: 'bold', marginRight: '2px' }}
                className="gui-def-button"
              >
                {translate('Go')}
              </button>
              <button id="scanGiftCardCancelButton" className="gui-def-button">
                {translate('Cancel')}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </FlameTheme>
  );
};
